
export enum VehicleFullColumnId {
    name = 1,
    status = 2,
    time = 3,
    speed = 4,
    adress = 5,
    driver = 6,
    etoll = 7,
    sent = 8,
    gps = 9,
    gsm = 10,
    fuel = 11,
    rpm = 12,
    sensor = 13,
    tacho = 14,
    numberId = 15,
    id = 16,
    lock = 17,
    networkType = 18,
    group = 19,
};
